import { Helmet } from 'react-helmet-async'

export function UserProfileHelmet({ user }) {
  if (!user) return null

  const fullName = user.nickname || 'משתמש AniZone'
  const userTag = user.userTag ? ` (${user.userTag})` : ''
  const joined = new Date(user.createdAt).toLocaleDateString('he-IL')

  const favoriteAnime = user.favoriteAnime
    ? ` אוהב את האנימה "${user.favoriteAnime}"`
    : ''
  const favoriteCharacter = user.favoriteCharacter
    ? ` והדמות האהובה עליו היא "${user.favoriteCharacter}"`
    : ''

  const description = `${fullName}${userTag} הוא חלק מקהילת AniZone מאז ${joined}.${favoriteAnime}${favoriteCharacter}. בדף הפרופיל תמצאו דירוגים, תגובות וכתבות מקוריות.`

  const image = user.image || 'https://anizone.co.il/default-user.jpg'
  const url = `https://www.anizone.co.il/user/${user.username}`

  return (
    <Helmet prioritizeSeoTags>
      {/* 🧠 Title & Meta */}
      <title>{`${fullName} | פרופיל משתמש - AniZone`}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* 🌐 Open Graph */}
      <meta property="og:type" content="profile" />
      <meta property="og:site_name" content="AniZone" />
      <meta property="og:title" content={`${fullName} | פרופיל ב-AniZone`} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* 🐦 Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${fullName} | פרופיל ב-AniZone`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={url} />

      {/* 🧩 JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Person',
            name: fullName,
            url,
            image,
            jobTitle: user.userTag || 'חובב אנימה',
            description: user.bio || description,
            sameAs: [],
          }),
        }}
      />
    </Helmet>
  )
}
